<template>
    <v-dialog width="500" v-model="showtripeditodometer">
        <v-card>
            <v-card-title class="secondary white--text">
                <span> Edit Odometer Reading {{ tripDetails.trip_id }}</span>

                <v-spacer></v-spacer>

                <v-btn icon @click="resetForm(), (showtripeditodometer = false)">
                    <v-icon class="white--text">mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="pt-2">
                <v-form ref="tripStartOdometer" v-if="showtripeditodometer" v-model="isValid">
                    <v-row class="my-0">
                        <v-col cols="12" class="Form-Columns">
                            <InputField type="number" :label="`Start Odometer Reading *`" required :rules="[
                                (val) => !!val || 'Start Odometer Reading is Required!',
                            ]" hide-details="auto" v-model="tripDetails.trip_start_km"
                                :error-messages="formErrors.trip_start_km" @input="delete formErrors.trip_start_km" />
                        </v-col>
                        <v-col cols="12" class="Form-Columns">
                            <InputField type="number" :label="`End Odometer Reading *`" required
                                :rules="[(val) => !!val || 'End Odometer Reading is Required!']" hide-details="auto"
                                v-model="tripDetails.trip_end_km" :error-messages="formErrors.trip_end_km"
                                @input="delete formErrors.trip_end_km" />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions class="justify-end">
                <v-btn color="primary" depressed :disabled="!isValid" @click="submitForm">
                    Submit
                </v-btn>

                <v-btn class="ml-3" color="secondary" depressed @click="resetForm">
                    Reset
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";


export default {
    components: {
        InputField,

    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        tripID: {
            type: [Number, null],
            default: null,
        }


    },
    watch: {
        value(val) {
            if (val) {
                this.getTripDetails(this.tripID)
            } else {
                this.resetForm();
            }
        },
    },
    computed: {
        showtripeditodometer: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    data() {
        return {
            isValid: true,
            isTextInput: false,
            formErrors: {},
            tripDetails: {},
        };
    },
    methods: {
        submitForm() {
            this.$bus.$emit("showLoader", true);

            this.$api.trip
                .editOdometerReading({
                    id: this.tripDetails.id,
                    data: {
                        trip_start_km: this.tripDetails.trip_start_km,
                        trip_end_km: this.tripDetails.trip_end_km,
                    },
                })
                .then((res) => {
                    this.$bus.$emit("showLoader", false);
                    this.$bus.$emit("showToastMessage", {
                        message: "Odometer updated successfully!",
                        color: "success",
                    });
                    this.resetForm();
                    this.showtripeditodometer = false;
                    this.$emit("refreshList");
                })
                .catch((err) => {

                    this.$bus.$emit("showLoader", false);
                    this.$bus.$emit("showToastMessage", {
                        message: `${err.data && err.data.error
                            ? err.data.error
                            : "Couldn't update Trip"
                            }`,
                        color: "error",
                    });

                    this.formErrors = err.data;
                });

        },

        resetForm() {
            if (this.$refs.tripStartOdometer) {
                this.$refs.tripStartOdometer.reset();
            }
            this.tripDetails = {};
        },

        async getTripDetails(id) {
            try {
                this.$bus.$emit("showLoader", true);

                const res = await this.$api.trip.getTripObject(id);
                console.log(res)
                this.tripDetails = res.data;

            } catch (err) {
                console.error(err);
            } finally {
                this.$bus.$emit("showLoader", false);
            }
        }



    },

};
</script>
